import script from "./OrderProcessing.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderProcessing.vue?vue&type=script&setup=true&lang=js"

import "./OrderProcessing.vue?vue&type=style&index=0&id=dcd2f8c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcd2f8c4"]])

export default __exports__